import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import EducationExperience from 'models/EducationExperience';
import { axiosBaseQuery } from 'services/api';

const EDUCATION_EXPERIENCE_TAG = 'EducationExperience';

export const educationExperienceApi = createApi({
  reducerPath: 'educationExperienceApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/education_experiences/',
  }),
  tagTypes: [EDUCATION_EXPERIENCE_TAG],
  endpoints: builder => ({
    // Returns undefined during loading or a List of EducationExperience instances sorted by id
    getEducationExperience: builder.query({
      query: userId => ({
        url: `?user=${userId}`,
      }),
      transformResponse: response =>
        List(Array.isArray(response) ? response.map(exp => new EducationExperience(exp)) : [])
          .sort((a, b) => a.id - b.id),
      providesTags: [EDUCATION_EXPERIENCE_TAG],
    }),
    createEducationExperience: builder.mutation({
      query: educationExperienceData => ({
        url: '',
        method: 'POST',
        data: educationExperienceData,
      }),
      transformResponse: response => new EducationExperience(response),
      invalidatesTags: [EDUCATION_EXPERIENCE_TAG],
    }),
    updateEducationExperience: builder.mutation({
      query: ({ id, ...educationExperienceData }) => ({
        url: `${id}/`,
        method: 'PATCH',
        data: educationExperienceData,
      }),
      transformResponse: response => new EducationExperience(response),
      invalidatesTags: [EDUCATION_EXPERIENCE_TAG],
    }),
    deleteEducationExperience: builder.mutation({
      query: educationExperienceId => ({
        url: `${educationExperienceId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [EDUCATION_EXPERIENCE_TAG],
    }),
  }),
});

export const {
  useGetEducationExperienceQuery,
  useCreateEducationExperienceMutation,
  useUpdateEducationExperienceMutation,
  useDeleteEducationExperienceMutation,
} = educationExperienceApi;
